/**
 * Global FAQ accordion (.ax-faq). Uses native <details>; optional hash deep-link.
 */
(function (window) {
  function initAxFaq() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var id = hash.slice(1);
    var el;
    try {
      el = document.getElementById(id);
    } catch (e) {
      return;
    }

    if (!el || !el.classList.contains("ax-faq__item")) return;

    el.open = true;
    window.requestAnimationFrame(function () {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  window.initAxFaq = initAxFaq;
})(window);
